import { Context } from "@silvertours/front-shared";
var useClientContext = Context.useClientContext;
// have to do this because type assertion functions have some stupid restrictions
var hasContext = Context.guardContext;
var useHost = function() {
    var result = useClientContext("host");
    hasContext("host", result);
    var _value = result.value, baseUrl = _value.baseUrl, baseImageUrl = _value.baseImageUrl;
    return {
        alternativeBaseUrls: baseUrl.alternatives,
        baseUrl: baseUrl.current,
        formatImage: function formatImage(path) {
            if (!path) {
                return "";
            }
            var join = path.indexOf("/") === 0 ? "" : "/";
            if (path.indexOf("/car_image.php") === 0) {
                // car_image.php only works with '290' width at the moment
                return "".concat(baseUrl.current).concat(join).concat(path.replace(/width=120/, "width=290"));
            }
            return "".concat(baseImageUrl).concat(join).concat(path);
        }
    };
};
export { useHost };
